var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.967188 30C0.967188 20.8267 2.72719 13.6 6.24719 8.32C9.82052 3.04 15.5539 0.399995 23.4472 0.399995C31.3405 0.399995 37.0472 3.04 40.5672 8.32C44.1405 13.6 45.9272 20.8267 45.9272 30C45.9272 39.28 44.1405 46.56 40.5672 51.84C37.0472 57.12 31.3405 59.76 23.4472 59.76C15.5539 59.76 9.82052 57.12 6.24719 51.84C2.72719 46.56 0.967188 39.28 0.967188 30ZM32.4872 30C32.4872 24.6133 31.9005 20.48 30.7272 17.6C29.5539 14.6667 27.1272 13.2 23.4472 13.2C19.7672 13.2 17.3405 14.6667 16.1672 17.6C14.9939 20.48 14.4072 24.6133 14.4072 30C14.4072 33.6267 14.6205 36.64 15.0472 39.04C15.4739 41.3867 16.3272 43.3067 17.6072 44.8C18.9405 46.24 20.8872 46.96 23.4472 46.96C26.0072 46.96 27.9272 46.24 29.2072 44.8C30.5405 43.3067 31.4205 41.3867 31.8472 39.04C32.2739 36.64 32.4872 33.6267 32.4872 30ZM51.7147 14.32V1.6H73.8747V60H59.6347V14.32H51.7147Z",
    fill: "#E4DEEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.0e3280a7efa7b62b17805b11110d43aa.svg";
export { ForwardRef as ReactComponent };